var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { IconBaseSvg } from "../icon-base";
var SyncProblemIcon = function (props) { return (React.createElement(IconBaseSvg, __assign({}, props, { viewBox: "0 0 24 24" }),
    React.createElement("g", { id: "Icon/ic_sync_problem", strokeWidth: "0" },
        React.createElement("path", { d: "M3,12a7.925,7.925,0,0,0,2.36,5.64L3.85,19.15a.5.5,0,0,0,.36.85H8.5a.5.5,0,0,0,.5-.5V15.21a.5.5,0,0,0-.85-.35L6.76,16.25A6,6,0,0,1,8.43,6.58.935.935,0,0,0,9,5.74V5.55a.917.917,0,0,0-1.32-.82A7.991,7.991,0,0,0,3,12Zm8,5h2V15H11ZM19.79,4H15.5a.5.5,0,0,0-.5.5V8.79a.5.5,0,0,0,.85.35l1.39-1.39a6,6,0,0,1-1.67,9.67.935.935,0,0,0-.57.84v.18a.917.917,0,0,0,1.32.82,7.951,7.951,0,0,0,2.32-12.9l1.51-1.51A.5.5,0,0,0,19.79,4ZM12,13a1,1,0,0,0,1-1V8a1,1,0,0,0-2,0v4A1,1,0,0,0,12,13Z", transform: "translate(-3, -4)" })))); };
export default SyncProblemIcon;
//# sourceMappingURL=SyncProblemIcon.js.map